import { Route } from "react-router-dom";

// EXPORTED COMPONENT
// ==============================
const PublicRoute = (props: any) => {
  const {
    currentUser,
    showHeader,
    showFooter,
    component: Component,
    path,
    backgroundColor,
    layout: Layout,
    ...rest
  } = props;

  return (
    <Route
      {...rest}
      path={path}
      render={(args) => (
        <Layout
          currentUser={currentUser}
          backgroundColor={backgroundColor}
          showHeader={showHeader}
          showFooter={showFooter}
        >
          <Component currentUser={currentUser} {...args} />
        </Layout>
      )}
    />
  );
};

// EXPORT
// ==============================
export default PublicRoute;
